import RpcService   from '@/core/services/Rpc/RpcService';
import RpcResponse   from '@/core/services/Rpc/RpcResponse';

import type CharacteristicUnit from '@/domains/CharacteristicUnits/CharacteristicUnit';
import type RpcDataPagination  from '@/core/services/Rpc/RpcDataPagination';
import type RpcDataSort        from '@/core/services/Rpc/RpcDataSort';

class CharacteristicUnitsDAO {

	static async getList(
		filters?: {
      id?: number;
      pattern?: string;
      name?: string;
      isDeleted?: boolean;
    },
		pagination?: RpcDataPagination,
		sort?: RpcDataSort,
	): Promise<RpcResponse> {
		return await RpcService.makeRequest(
			'characteristicUnits.getList',
      {
        ...filters,
      },
			pagination,
			sort,
			true, null, null, false,
			{ abortPrevious: true },
		);
	}

	static async add(unit: CharacteristicUnit): Promise<RpcResponse> {
		return await RpcService.makeRequest('characteristicUnits.add', { unit });
	}

	static async update(unit: CharacteristicUnit): Promise<RpcResponse> {
		return await RpcService.makeRequest('characteristicUnits.update', { unit });
	}

	static async delete(id: number): Promise<RpcResponse> {
		return await RpcService.makeRequest('characteristicUnits.delete', { id });
	}
}

export default CharacteristicUnitsDAO;
